/**
 * Централизованный error logger.
 * Любое место в коде должно писать ошибки через logError, а не напрямую console.error —
 * это даёт один рычаг для подключения телеметрии.
 *
 * Phase 7: Sentry integration point. Подключение:
 *   1) npm i @sentry/nextjs
 *   2) npx @sentry/wizard -i nextjs
 *   3) SENTRY_DSN в env, globalThis.Sentry автоматически инициализируется
 * Дальше все logError() автоматически идут в Sentry. AbortError фильтруется здесь.
 */

type Sentry = {
    captureException?: (err: unknown, extra?: Record<string, unknown>) => void
}

export function logError(context: string, err: unknown, extra?: Record<string, unknown>) {
    // Filter AbortError — штатная отмена (cleanup, AbortController), не настоящая ошибка.
    const name = (err as { name?: string })?.name
    if (name === 'AbortError') return

    const prefix = `[${context}]`
    if (extra) console.error(prefix, err, extra)
    else console.error(prefix, err)

    // Sentry integration point (опционально).
    const sentry = (globalThis as unknown as { Sentry?: Sentry }).Sentry
    if (sentry?.captureException) {
        try { sentry.captureException(err, { tags: { context }, extra }) }
        catch { /* swallow — не ломаем user flow из-за Sentry */ }
    }
}
